module.exports = __webpack_public_path__ + "img/carro-portaflejes.4c0ad2f0.jpg";